import React, { useCallback, useEffect } from 'react';
import { RouteComponentProps } from 'react-router';
import DefaultLocales from 'globals/locales/default';
import { observer } from 'mobx-react';
import FsButton from 'ui-elements/buttons/FsButton';
import { Alert, AlertTitle } from '@material-ui/lab';
import FsBody from 'ui-elements/typography/FsBody';
import FsBodyBold from 'ui-elements/typography/FsBodyBold';
import reportLocales from 'globals/locales/report';
import { Box } from '@material-ui/core';
import Routes from 'routes';
import FsDialogTitle from 'ui-elements/modals/FsDialogTitle';
import { ModalState } from 'globals/types';
import {
  CustomDialog,
  DialogActions,
  DialogContent,
  RelativeSendButtonWrapperBox,
} from '../ReportModals.style-elements';
import { ReportChangeCategoryModalLocationStateProps } from '../ReportChangeCategoryModal/ReportChangeCategoryModal';

const { close: closeLabel } = DefaultLocales;

const {
  dialogTitle,
  alertTitle,
  alertDescription,
} = reportLocales.changeCategoryModalFail;

const ReportChangeCategoryModalFail: React.FC<RouteComponentProps> = ({
  history,
  location,
}) => {
  const modalState = location.state as ReportChangeCategoryModalLocationStateProps;
  const status = modalState?.success || false;

  const redirect = useCallback((): void => {
    history.push({ pathname: Routes.REPORT });
  }, [history]);

  const handleClose = (): void => {
    redirect();
  };

  useEffect(() => {
    if (status !== ModalState.FAIL) redirect();
  }, [status, redirect]);

  return (
    <CustomDialog
      disableEnforceFocus
      open
      fullWidth
      maxWidth="sm"
      onClose={handleClose}
      data-test="report-change-category-modal-fail"
    >
      <FsDialogTitle
        id="report-change-category-modal-fail"
        onClose={handleClose}
      >
        {dialogTitle}
      </FsDialogTitle>

      <DialogContent dividers>
        <Alert severity="error">
          <AlertTitle>
            <FsBodyBold>{alertTitle}</FsBodyBold>
          </AlertTitle>
          <FsBody>{alertDescription[0]}</FsBody>
          <FsBody>{alertDescription[1]}</FsBody>
          <Box marginTop={2}>
            <FsBody>{alertDescription[2]}</FsBody>
          </Box>
        </Alert>
      </DialogContent>
      <DialogActions>
        <RelativeSendButtonWrapperBox>
          <FsButton onClick={handleClose} variant="contained" color="primary">
            {closeLabel}
          </FsButton>
        </RelativeSendButtonWrapperBox>
      </DialogActions>
    </CustomDialog>
  );
};

export default observer(ReportChangeCategoryModalFail);
